import { render } from "./modal-remove-schools-from-district.vue?vue&type=template&id=58c6d04a&scoped=true"
import script from "./modal-remove-schools-from-district.vue?vue&type=script&lang=js"
export * from "./modal-remove-schools-from-district.vue?vue&type=script&lang=js"

import "./modal-remove-schools-from-district.vue?vue&type=style&index=0&id=58c6d04a&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c6d04a"],['__file',"src/components/admin-dashboard/modals/modal-remove-schools-from-district.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58c6d04a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58c6d04a', __exports__)) {
    api.reload('58c6d04a', __exports__)
  }
  
  module.hot.accept("./modal-remove-schools-from-district.vue?vue&type=template&id=58c6d04a&scoped=true", () => {
    api.rerender('58c6d04a', render)
  })

}


export default __exports__